'use client';
import { isBrowser } from '@s7/platform';
import { max } from '@s7/utils';

const parse = (x)=>parseInt(x || '', 10) || 0;
const getOffset = ()=>{
    const cs = window.getComputedStyle(document.body);
    const left = cs.marginLeft;
    const top = cs.marginTop;
    const right = cs.marginRight;
    return [
        parse(left),
        parse(top),
        parse(right)
    ];
};
const zeroGap = [
    0,
    0,
    0,
    0
];
const getGapWidth = ()=>{
    if (!isBrowser) {
        return zeroGap;
    }
    const offsets = getOffset();
    const documentWidth = document.documentElement.clientWidth;
    const windowWidth = window.innerWidth;
    return [
        offsets[0],
        offsets[1],
        offsets[2],
        max(0, windowWidth - documentWidth + offsets[2] - offsets[0])
    ];
};

export { getGapWidth, zeroGap };
//# sourceMappingURL=utils.js.map
